module.exports = __webpack_public_path__ + "static/img/notice13.f50eae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice13.png
// module id = wSlf
// module chunks = 2